import { OnInit } from "@angular/core";
var Tipo_autorizacionComponent = /** @class */ (function () {
    function Tipo_autorizacionComponent() {
        this.rows = [];
        this.autorizacion = { "DEMOLICION": false, "MODIFICACION": false, "OBRA PRELIMINAR": false };
        if (!JSON.parse(localStorage.getItem("tipo_autorizacion"))) {
            console.log("nuevo");
            localStorage.setItem("tipo_autorizacion", JSON.stringify(this.rows));
        }
        else {
            console.log("desde borrador");
            this.rows = JSON.parse(localStorage.getItem("tipo_autorizacion"));
            this.autorizacion = {
                "DEMOLICION": this.rows[0].autorizacion["DEMOLICION"] == true ? true : false,
                "MODIFICACION": this.rows[0].autorizacion["MODIFICACION"] == true ? true : false,
                "OBRA PRELIMINAR": this.rows[0].autorizacion["OBRA PRELIMINAR"] == true ? true : false,
            };
        }
    }
    Tipo_autorizacionComponent.prototype.ngOnInit = function () {
        this.n_form = localStorage.getItem("form");
        console.log("Form", this.n_form);
    };
    Tipo_autorizacionComponent.prototype.add_tipo_autorizacion = function () {
        localStorage.setItem("tipo_autorizacion", JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_autorizacion");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            autorizacion: this.autorizacion
        });
        localStorage.setItem("tipo_autorizacion", JSON.stringify(this.rows));
        console.log(JSON.parse(localStorage.getItem("tipo_autorizacion")));
    };
    Tipo_autorizacionComponent.prototype.delete_tipo_autorizacion = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_autorizacion", JSON.stringify(this.rows));
            }
        }
    };
    return Tipo_autorizacionComponent;
}());
export { Tipo_autorizacionComponent };
